import { createContext } from 'react';
import { SettingsServiceTypes } from '../../types';

export const SettingsServiceContext = createContext<SettingsServiceTypes.ContextState>({
  loading: false,
  state: {} as any,
  broadcast: () => {}
});
